// Changelog data - in real app, this could come from an API
export const changes = [
  // ----------------------------------------------------------------------------
  // Version 1.9.3
  // ----------------------------------------------------------------------------
  {
    version: "1.9.3",
    date: "2026-07-01",
    description: "Bug fixes and polish",
    changes: [
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Tasks & Attachments",
            subBullets: [
              "Fixed image and file handling when creating a new task",
              "Fixed misleading position changes appearing when moving tasks between columns"
            ]
          },
          {
            bulletContent: "Releases & Layout",
            subBullets: [
              "Long release lists now scroll properly in the release dropdown",
              "Improved responsive layout for the project board and task details on smaller screens"
            ]
          },
          {
            bulletContent: "GitHub",
            subBullets: [
              "Pushed updates to a linked pull request now appear in the task timeline",
              "Fixed the loading spinner alignment in the link GitHub dialog"
            ]
          },
          {
            bulletContent: "Appearance",
            subBullets: [
              "Fixed code blocks displaying incorrectly in light mode"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.9.2
  // ----------------------------------------------------------------------------
  {
    version: "1.9.2",
    date: "2026-03-18",
    description: "Minor bug fixes and stability improvements",
    changes: [
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Bug fixes",
            subBullets: [
              "Fixed closed tasks still appearing on the project page",
              "Fixed duplicated GitHub activity entries in task timelines"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.9.0
  // ----------------------------------------------------------------------------
  {
    version: "1.9.0",
    date: "2026-03-15",
    description: "GitHub integration, comment editing, and smarter search",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "GitHub Integration",
            subBullets: [
              "Link GitHub commits and pull requests directly to tasks",
              "Automatically track development activity in your task timeline",
            ]
          },
          {
            bulletContent: "Edit Comments",
            subBullets: [
              "Edit your comments after posting to fix typos or update information",
            ]
          }
        ]
      },
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Search",
            subBullets: [
              "Faster, more accurate search results with improved ranking",
              "Better handling of task key lookups and command searches",
            ]
          },
          {
            bulletContent: "Reliability",
            subBullets: [
              "General stability improvements and bug fixes",
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.8.6
  // ----------------------------------------------------------------------------
  {
    version: "1.8.6",
    date: "2025-02-01",
    description: "Platform reliability and performance enhancements",
    changes: [
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "System Reliability",
            subBullets: [
              "General stability improvements and bug fixes"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.8.5
  // ----------------------------------------------------------------------------
  {
    version: "1.8.5",
    date: "2025-01-04",
    description: "Smarter AI assistant with conversation history",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Conversation History",
            subBullets: [
              "Save and revisit previous AI conversations",
              "Continue where you left off with multi-turn conversations",
            ]
          }
        ]
      },
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "AI Assistant",
            subBullets: [
              "Faster and more accurate responses",
              "Better understanding of your current context",
              "More accurate search results"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.8.0
  // ----------------------------------------------------------------------------
  {
    version: "1.8.0",
    date: "2025-12-21",
    description: "Enhanced monitoring with Bot Insights, notification center, and UI improvements",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Enhanced Browser Agent Monitoring with Bot Insights",
            subBullets: [
              "Live streaming of browser agent actions during monitor runs",
              "AI-powered evaluation and insights using LLM review of completed steps"
            ]
          },
          {
            bulletContent: "Notification Center",
            subBullets: [
              "New notification dropdown and dedicated notifications page",
              "Monitor failure and recovery notifications with email support (Beta)"
            ]
          },
          {
            bulletContent: "Mobile App (Early Beta)",
            subBullets: [
              "Native iOS and Android apps in early beta, coming soon to app stores"
            ]
          }
        ]
      },
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Monitor Experience",
            subBullets: [
              "Live polling keeps monitor runs updated in real-time",
              "Optimized monitor list and details page performance",
              "Improved monitor run view with better status indicators"
            ]
          },
          {
            bulletContent: "User Interface",
            subBullets: [
              "Redesigned top navigation bar with improved profile and settings access",
              "New notification dropdown for quick access to alerts",
              "Enhanced monitor dropdown for quick navigation"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.7.6
  // ----------------------------------------------------------------------------
  {
    version: "1.7.6",
    date: "2025-12-17",
    description: "Automatic updates and stability improvements",
    changes: [
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Automatic Updates",
            subBullets: [
              "StatusBot now automatically refreshes when new versions are available"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.7.5
  // ----------------------------------------------------------------------------
  {
    version: "1.7.5",
    date: "2025-11-30",
    description: "Task subscriptions, dynamic status triggers, multi-file uploads, and more",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Task Subscriptions",
            subBullets: [
              "Subscribe to tasks to receive updates on activity",
              "Improved notification delivery for subscribed tasks"
            ]
          },
          {
            bulletContent: "Dynamic Complete Triggers",
            subBullets: [
              "Configure which statuses trigger task completion per project",
              "Close tasks without completing them for cancelled or abandoned work"
            ]
          },
          {
            bulletContent: "Multi-File Uploads",
            subBullets: [
              "Upload multiple files at once with improved drag and drop",
              "Better file handling and attachment management"
            ]
          }
        ]
      },
      {
        changeTitle: "Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Performance & Stability",
            subBullets: [
              "Faster page loading and smoother rendering",
              "Various bug fixes and stability improvements"
            ]
          }
        ]
      }
    ]
  },
  // ----------------------------------------------------------------------------
  // Version 1.7.2
  // ----------------------------------------------------------------------------
  {
    version: "1.7.2",
    date: "2025-11-08",
    description: "Enhanced task creation and navigation improvements",
    changes: [
      {
        changeTitle: "User Experience",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Task Creation Improvements",
            subBullets: [
              "Added quick access to recent projects in navigation",
              "Create tasks from anywhere with improved dialog",
              "Enhanced task list with create button"
            ]
          }
        ]
      }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.7.1
  // ----------------------------------------------------------------------------
  {
    version: "1.7.1",
    date: "2025-11-02",
    description: "Bug fixes and improvements for task filtering and status handling",
    changes: [
      {
        changeTitle: "Bug Fixes",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Task Management Improvements",
            subBullets: [
              "Fixed status filtering issues in unified task view",
              "Resolved scope column display and selection problems",
              "Corrected multi-select move operations for backlog and release assignment",
              "Enhanced status handling consistency across task views",
              "Improved frontend caching for better performance and faster page loads"
            ]
          }
        ]
      }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.7.0
  // ----------------------------------------------------------------------------
  {
    version: "1.7.0",
    date: "2025-10-10",
    description: "Enhanced task filtering with labels, improved monitoring capabilities, and refined user experience",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Task Management Enhancements",
            subBullets: [
              "Added label filtering to unified task search with intelligent deduplication",
              "Introduced task context menu with copy and share functionality",
              "Enhanced scope selection for new tasks (Active Week/Backlog/Release)",
              "Improved label visualization in task tables and cards"
            ]
          },
          {
            bulletContent: "Monitor Improvements",
            subBullets: [
              "Added SSL certificate validation for ping monitors",
              "Removed some legacy monitor environments"
            ]
          },
        ]
      },
      {
        changeTitle: "User Experience",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Interface Refinements",
            subBullets: [
              "Implemented loading states for buttons with spinner animations",
              "Adjusted color scheme for improved consistency in dialogs",
              "Enhanced task table layout and responsiveness"
            ]
          }
        ]
      },
      {
        changeTitle: "Bug Fixes",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Resolved Issues",
            subBullets: [
              "Fixed task creation in backlog with inactive releases",
              "Corrected quick-add task scope handling",
              "Improved aggregation pipeline for label display consistency"
            ]
          }
        ]
      }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.6.8
  // ----------------------------------------------------------------------------
  {
    version: "1.6.8",
    date: "2025-09-13",
    description: "Unified task management with AI-powered sorting and improved due date tracking",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Unified Tasks Page",
            subBullets: [
              "New centralized tasks view with advanced filtering and pagination",
              "AI-powered 'Bot Sort' functionality for intelligent task prioritization"
            ]
          }
        ]
      },
      {
        changeTitle: "User Experience",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Task Display Enhancements",
            subBullets: [
              "Improved due date display with completion and shipping status indicators",
              "Enhanced on-time tracking visibility"
            ]
          },
          {
            bulletContent: "Search & Performance",
            subBullets: [
              "Refactored search architecture with enhanced query building",
              "Improved task filtering capabilities"
            ]
          }
        ]
      }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.6.5
  // ----------------------------------------------------------------------------
  {
    version: "1.6.5",
    date: "2025-08-17",
    description: "Enhanced AI search capabilities, improved Today page insights, and added image dialog feature",
    changes: [
      {
        changeTitle: "AI Improvements",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Enhanced AI Search",
            subBullets: [
              "Major refactoring of AI search architecture for better performance",
              "Improved context awareness and search accuracy"
            ]
          },
          {
            bulletContent: "Today Page Enhancements",
            subBullets: [
              "Improved Today page context handling and insight generation",
              "Added caching for better performance of insight generation",
              "Enhanced Today insight chat with additional options"
            ]
          }
        ]
      },
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Image Dialog",
            subBullets: [
              "Enhanced attachment handling with improved image lightbox functionality"
            ]
          }
        ]
      },
      {
        changeTitle: "User Experience",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Interface Improvements",
            subBullets: [
              "Fixed light mode display issues for release dropdown",
              "Improved error handling and edge case management",
              "Enhanced overall UI consistency and responsiveness"
            ]
          }
        ]
      }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.6.0
  // ----------------------------------------------------------------------------
  {
    version: "1.6.0",
    date: "2025-08-10",
    description: "Introducing Release Groups and a new Release view; Backlog is now a planning space",
    changes: [
      {
        changeTitle: "New Features",
        changeType: "feature",
        changeBullets: [
          {
            bulletContent: "Release Groups",
            subBullets: [
              "Group tasks into releases",
              "Plan work in Backlog and move to your Active week"
            ]
          },
          {
            bulletContent: "Release View (Beta)",
            subBullets: [
              "Visual timeline for planning and tracking releases"
            ]
          }
        ]
      },
      {
        changeTitle: "Workflow Update",
        changeType: "improvement",
        changeBullets: [
          {
            bulletContent: "Backlog is no longer a status",
            subBullets: [
              "Backlog is your planning space; use releases or move tasks directly to Active week"
            ]
          }
        ]
      }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.5.0
  // ----------------------------------------------------------------------------
  {
    version: "1.5.0",
    date: "2025-05-07",
    description: "Introduced context-aware AI command palette and company ownership update",
    changes: [
        {
            changeTitle: "New Features",
            changeType: "feature",
            changeBullets: [
                {
                    bulletContent: "AI Command Palette",
                    subBullets: [
                        "Added smart AI-powered command suggestions",
                        "Improved command discovery and execution"
                    ]
                },
                {
                    bulletContent: "Context Awareness",
                    subBullets: [
                        "Enhanced awareness of workspace environment",
                        "Smarter suggestions based on current tasks"
                    ]
                }
            ]
        },
        {
            changeTitle: "User Experience",
            changeType: "improvement",
            changeBullets: [
                {
                    bulletContent: "Interface Improvements",
                    subBullets: [
                        "Redesigned command palette for better usability",
                        "Enhanced task modal with improved UX and layout"
                    ]
                },
                {
                    bulletContent: "General bug fixes and improvements",
                    subBullets: [
                        "Various notification system improvements",
                        "Multiple performance enhancements",
                        "Fixed several UI inconsistencies"
                    ]
                }
            ]
        },
        {
            changeTitle: "Company Update",
            changeType: "announcement",
            changeBullets: [
                {
                    bulletContent: "Ownership Change",
                    subBullets: [
                        "StatusBot, Inc. is now the official owner of StatusBot",
                        "New corporate structure to support continued growth"
                    ]
                }
            ]
        }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.4.0
  // ----------------------------------------------------------------------------
  {
    version: "1.4.0",
    date: "2025-04-06",
    description: "New & improved monitor server architecture in preparation for browser agent monitoring",
    changes: [
        {
            changeTitle: "New Features",
            changeType: "feature",
            changeBullets: [
                {
                    bulletContent: "Faster monitor runs",
                    subBullets: [
                        "Improved monitor run architecture"
                    ]
                },
                {
                    bulletContent: "Enhanced member invite management",
                    subBullets: [
                        "View pending and expired invites",
                        "Resend & delete invites"
                    ]
                }
            ]
        },
        {
            changeTitle: "Platform Improvements",
            changeType: "improvement",
            changeBullets: [
                {
                    bulletContent: "User Interface",
                    subBullets: [
                        "Enhanced mobile responsiveness for project headers",
                    ]
                }
            ]
        }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.3.2
  // ----------------------------------------------------------------------------
  {
    version: "1.3.2",
    date: "2025-03-15",
    description: "Enhanced monitoring system stability, improved user experience, and various UI improvements",
    changes: [
        {
            changeTitle: "New Features",
            changeType: "feature",
            changeBullets: [
                {
                    bulletContent: "Enhanced Task Management",
                    subBullets: [
                        "Made backlog visible by default in list view",
                        "Implemented dynamic status management",
                        "Added horizontal scrolling for board columns"
                    ]
                },
                {
                    bulletContent: "Improved Onboarding",
                    subBullets: [
                        "Added team information collection during signup"
                    ]
                },
                {
                    bulletContent: "Monitor Enhancements",
                    subBullets: [
                        "Implemented automatic monitor name generation",
                        "Enhanced monitor security endpoints",
                        "Improved SSL certificate handling for path monitoring",
                        "Enhanced monitor initialization process"
                    ]
                }
            ]
        },
        {
            changeTitle: "Platform Improvements",
            changeType: "improvement",
            changeBullets: [
                {
                    bulletContent: "System Optimization",
                    subBullets: [
                        "Enhanced cron job management system",
                        "Optimized monitor runs architecture",
                        "Improved system reliability and performance"
                    ]
                },
                {
                    bulletContent: "User Interface",
                    subBullets: [
                        "Enhanced mobile responsiveness for task details",
                        "Improved overall user experience"
                    ]
                }
            ]
        }
    ]
  },

  // ----------------------------------------------------------------------------
    // Version 1.3.1
    // ----------------------------------------------------------------------------
    {
        version: "1.3.1",
        date: "2025-02-25",
        description: "Introduced filtering and sorting features, enhanced step indicators, improved link support, and refined attachment handling",
        changes: [
            {
                changeTitle: "New Features",
                changeType: "feature",
                changeBullets: [
                    {
                        bulletContent: "Filtering & Sorting Enhancements",
                        subBullets: [
                            "Implemented advanced filtering and sorting for better task organization",
                            "Enhanced column management for improved workflow"
                        ]
                    },
                    {
                        bulletContent: "Link Management",
                        subBullets: [
                            "Enhanced link formatting capabilities",
                            "Improved link management interface",
                            "Streamlined link-related actions for better usability"
                        ]
                    },
                    {
                        bulletContent: "File Management",
                        subBullets: [
                            "Enhanced file upload and management system",
                            "Improved attachment handling for various file types",
                            "Streamlined file download experience"
                        ]
                    }
                ]
            },
            {
                changeTitle: "Enhancements",
                changeType: "improvement",
                changeBullets: [
                    {
                        bulletContent: "Monitor Management",
                        subBullets: [
                            "Enhanced progress tracking visualization",
                            "Improved security measures for monitor updates",
                            "Enhanced access control system"
                        ]
                    },
                    {
                        bulletContent: "User Interface Updates",
                        subBullets: [
                            "Improved form styling and consistency",
                            "Enhanced input field interactions",
                            "Streamlined user experience across the platform"
                        ]
                    }
                ]
            }
        ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.3.0
    // ----------------------------------------------------------------------------
    {
      version: "1.3.0",
      date: "2025-02-21",
      description: "Introduced intelligent monitoring with predictive analytics and automated incident response",
      changes: [
        {
          changeTitle: "New Features",
          changeType: "feature",
          changeBullets: [
            {
              bulletContent: "Access Management",
              subBullets: [
                "Implemented streamlined waitlist system",
                "Enhanced user onboarding process",
                "Added automated notification system for access updates"
              ]
            },
            {
              bulletContent: "Media Support",
              subBullets: [
                "Enhanced comment system with image support",
                "Improved media handling capabilities"
              ]
            }
          ]
        },
        {
          changeTitle: "Platform Improvements",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "System Enhancements",
              subBullets: [
                "Improved authentication system",
                "Enhanced form validation and error handling",
                "Optimized mobile experience",
                "Improved overall system performance"
              ]
            }
          ]
        }
      ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.2.9
    // ----------------------------------------------------------------------------
    {
      version: "1.2.9",
      date: "2025-02-12",
      description: "Enhanced AI capabilities for improved task context understanding",
      changes: [
        {
          changeTitle: "AI Enhancements",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Intelligent Task Management",
              subBullets: [
                "Enhanced AI system for better task context understanding",
                "Improved task organization through AI assistance"
              ]
            }
          ]
        }
      ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.2.8
    // ----------------------------------------------------------------------------
    {
      version: "1.2.8",
      date: "2025-02-07",
      description: "Enhanced authentication experience and improved task organization",
      changes: [
        {
          changeTitle: "User Experience",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Authentication Improvements",
              subBullets: [
                "Introduced streamlined login experience with Magic Link",
                "Enhanced user authentication flow"
              ]
            },
            {
              bulletContent: "Task Organization",
              subBullets: [
                "Enhanced task categorization with visual improvements",
                "Improved task label management system"
              ]
            }
          ]
        },
        {
          changeTitle: "Collaboration Features",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Enhanced Communication",
              subBullets: [
                "Improved comment system with enhanced mentions",
                "Optimized task description handling",
                "Enhanced notification system for better collaboration"
              ]
            }
          ]
        }
      ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.2.7
    // ----------------------------------------------------------------------------
    {
      version: "1.2.7",
      date: "2025-02-01",
      description: "Enhanced security measures and authentication system",
      changes: [
        {
          changeTitle: "Security",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Authentication Enhancements",
              subBullets: [
                "Implemented advanced security measures for improved user authentication",
                "Enhanced session management capabilities"
              ]
            }
          ]
        }
      ]
    },

    // Version 1.2.6
    // ----------------------------------------------------------------------------
    {
      version: "1.2.6",
      date: "2025-01-20",
      description: "Performance optimizations and improved user experience",
      changes: [
        {
          changeTitle: "Platform Improvements",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Performance Enhancements",
              subBullets: [
                "Improved loading states for better user experience",
                "Enhanced system responsiveness",
                "Optimized task component loading",
                "Improved project list performance"
              ]
            },
            {
              bulletContent: "Navigation Improvements",
              subBullets: [
                "Enhanced navigation system",
                "Improved UI consistency across the platform"
              ]
            }
          ]
        },
        {
          changeTitle: "User Management",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Email Handling",
              subBullets: [
                "Improved email management system",
                "Enhanced email handling consistency"
              ]
            }
          ]
        }
      ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.2.5
    // ----------------------------------------------------------------------------
    {
      version: "1.2.5",
      date: "2025-01-15",
      description: "Brand refresh and enhanced notification system",
      changes: [
        {
          changeTitle: "Platform Updates",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Brand Evolution",
              subBullets: [
                "Introduced new branding across the platform",
                "Enhanced visual consistency throughout the application"
              ]
            },
            {
              bulletContent: "Platform Optimization",
              subBullets: [
                "Improved search engine optimization",
                "Enhanced platform visibility"
              ]
            },
            {
              bulletContent: "Communication System",
              subBullets: [
                "Enhanced notification system with improved user controls",
                "Added comprehensive email notification preferences",
                "Improved notification delivery and clarity"
              ]
            }
          ]
        }
      ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.2.4
    // ----------------------------------------------------------------------------
    {
      version: "1.2.4",
      date: "2025-01-09",
      description: "Enhanced media handling and improved task management experience",
      changes: [
          {
              changeTitle: "Platform Improvements",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Media Management",
                      subBullets: [
                          "Enhanced image upload capabilities",
                          "Improved attachment handling system",
                          "Streamlined media integration in tasks"
                      ]
                  },
                  {
                      bulletContent: "Task Management",
                      subBullets: [
                          "Enhanced task description system",
                          "Improved editing experience"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.3
  // ----------------------------------------------------------------------------
  {
      version: "1.2.3",
      date: "2025-01-02",
      description: "Enhanced collaboration features and improved activity tracking",
      changes: [
          {
              changeTitle: "Collaboration Features",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Enhanced Text Editor",
                      subBullets: [
                          "Added advanced formatting options",
                          "Improved content management capabilities",
                          "Enhanced text storage format for better reliability"
                      ]
                  },
                  {
                      bulletContent: "Team Collaboration",
                      subBullets: [
                          "Introduced user mentions in comments and descriptions",
                          "Enhanced notification system for mentions",
                          "Improved activity timeline visualization"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.2
  // ----------------------------------------------------------------------------
  {
      version: "1.2.2",
      date: "2024-12-23",
      description: "Introduced task scheduling and enhanced activity tracking",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Scheduling",
                      subBullets: [
                          "Added due date functionality",
                          "Enhanced task organization features",
                          "Improved date handling across time zones"
                      ]
                  },
                  {
                      bulletContent: "Activity Tracking",
                      subBullets: [
                          "Enhanced activity timeline with improved organization",
                          "Streamlined activity tracking for better visibility"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.1
  // ----------------------------------------------------------------------------
  {
      version: "1.2.1",
      date: "2024-12-18",
      description: "Introduced project settings and enhanced task organization",
      changes: [
          {
              changeTitle: "Project Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Project Settings",
                      subBullets: [
                          "Introduced comprehensive project configuration options",
                          "Enhanced project management capabilities"
                      ]
                  },
                  {
                      bulletContent: "Task Organization",
                      subBullets: [
                          "Enhanced task labeling system",
                          "Improved task categorization features"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.0
  // ----------------------------------------------------------------------------
  {
      version: "1.2.0",
      date: "2024-12-06",
      description: "Enhanced task organization with improved categorization",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Categories",
                      subBullets: [
                          "Introduced comprehensive task labeling system",
                          "Enhanced task organization capabilities",
                          "Improved activity tracking for task updates"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.9
  // ----------------------------------------------------------------------------
  {
      version: "1.1.9",
      date: "2024-11-28",
      description: "Enhanced security and AI-powered search capabilities",
      changes: [
          {
              changeTitle: "Platform Security",
              changeType: "feature",
              changeBullets: [
                  {
                      bulletContent: "Security Enhancements",
                      subBullets: [
                          "Implemented advanced access control system",
                          "Enhanced organization security measures"
                      ]
                  },
                  {
                      bulletContent: "AI Integration",
                      subBullets: [
                          "Enhanced AI-powered search capabilities",
                          "Improved intelligent insights generation"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.8
  // ----------------------------------------------------------------------------
  {
      version: "1.1.8",
      date: "2024-11-21",
      description: "Improved time zone handling and task management",
      changes: [
          {
              changeTitle: "Global Usage",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Time Zone Management",
                      subBullets: [
                          "Enhanced time zone support for global teams",
                          "Improved date and time handling across regions"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.7
  // ----------------------------------------------------------------------------
  {
      version: "1.1.7",
      date: "2024-11-19",
      description: "Enhanced task creation and management capabilities",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Quick Task Creation",
                      subBullets: [
                          "Introduced Quick Add feature for faster task creation",
                          "Enhanced task creation workflow"
                      ]
                  }
              ]
          }
      ]
  },

  // Version 1.1.6
  // ----------------------------------------------------------------------------
  {
      version: "1.1.6",
      date: "2024-11-13",
      description: "Mobile experience improvements",
      changes: [
          {
              changeTitle: "Mobile Support",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Mobile Optimization",
                      subBullets: [
                          "Enhanced mobile responsiveness across core features",
                          "Improved mobile navigation and accessibility"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.5
  // ----------------------------------------------------------------------------
  {
      version: "1.1.5",
      date: "2024-11-10",
      description: "Enhanced monitoring capabilities and activity tracking",
      changes: [
          {
              changeTitle: "Platform Improvements",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Monitoring Enhancements",
                      subBullets: [
                          "Improved monitor management for organizations",
                          "Enhanced activity tracking visualization"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.4
  // ----------------------------------------------------------------------------
  {
      version: "1.1.4",
      date: "2024-11-08",
      description: "Enhanced task organization capabilities",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Multi-Task Management",
                      subBullets: [
                          "Introduced ability to manage multiple tasks simultaneously",
                          "Enhanced task organization features"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.3
  // ----------------------------------------------------------------------------
  {
      version: "1.1.3",
      date: "2024-11-02",
      description: "Improved task organization and sorting capabilities",
      changes: [
          {
              changeTitle: "Task Organization",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Management",
                      subBullets: [
                          "Enhanced task organization capabilities",
                          "Improved task sorting and categorization"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.2
  // ----------------------------------------------------------------------------
  {
      version: "1.1.2",
      date: "2024-10-27",
      description: "Enhanced task management system",
      changes: [
          {
              changeTitle: "Platform Improvements",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Management",
                      subBullets: [
                          "Improved task details management",
                          "Enhanced organization features"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.1
  // ----------------------------------------------------------------------------
  {
      version: "1.1.1",
      date: "2024-10-24",
      description: "Enhanced file management and notification system",
      changes: [
          {
              changeTitle: "Platform Features",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "File Management",
                      subBullets: [
                          "Enhanced file upload capabilities",
                          "Added support for larger file sizes",
                          "Improved drag and drop functionality"
                      ]
                  },
                  {
                      bulletContent: "Notifications",
                      subBullets: [
                          "Improved notification system integration"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.0
  // ----------------------------------------------------------------------------
  {
      version: "1.1.0",
      date: "2024-10-20",
      description: "System stability improvements",
      changes: [
          {
              changeTitle: "Platform Stability",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "System Improvements",
                      subBullets: [
                          "Enhanced system reliability",
                          "Improved error handling"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.0.0
  // ----------------------------------------------------------------------------
  {
      version: "1.0.0",
      date: "2024-09-29",
      description: "Initial platform release",
      changes: [
          {
              changeTitle: "Platform Launch",
              changeType: "feature",
              changeBullets: [
                  {
                      bulletContent: "Core Features",
                      subBullets: [
                          "Launched monitoring system",
                          "Implemented user authentication",
                          "Introduced task management",
                          "Added collaboration features"
                      ]
                  }
              ]
          }
      ]
  }
];
